var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRemoveInspector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_18740)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.953,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7646 1C44.4833 1 46.202 1 47.9208 1C49.6166 1.29592 51.2781 1.78289 52.9051 2.46092C50.9062 6.43954 47.6979 8.0437 43.2802 7.27336C40.6944 6.52039 38.861 4.91623 37.7803 2.46092C39.4072 1.78289 41.0687 1.29592 42.7646 1Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.989,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3115 4.9375C36.6933 10.9245 41.7922 13.3021 48.6084 12.0703C52.5232 10.9301 55.4163 8.55252 57.288 4.9375C61.9343 8.61412 64.5124 13.4266 65.0224 19.375C65.137 23.5572 65.137 27.7396 65.0224 31.9218C64.2481 40.0267 60.1518 45.7271 52.7334 49.0233C43.3349 52.1153 35.5146 49.8523 29.2725 42.2343C27.149 39.1299 25.9459 35.6924 25.6631 31.9218C25.5485 27.6822 25.5485 23.4427 25.6631 19.2031C26.2386 13.3525 28.788 8.59729 33.3115 4.9375Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4971 49.4684C28.9249 49.4337 29.326 49.5196 29.7002 49.7262C31.5812 51.3407 33.6724 52.6297 35.9736 53.5934C35.9966 55.663 36.1113 57.7255 36.3173 59.7809C36.6534 61.0543 37.1977 62.2287 37.9502 63.3043C36.9083 69.4124 35.8198 75.514 34.6845 81.609C30.7997 71.3286 27.0184 61.0162 23.3408 50.6716C25.1034 50.3739 26.8221 49.9729 28.4971 49.4684Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.967,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3281 49.4609C63.3373 49.8399 65.3426 50.2409 67.3437 50.6641C63.6661 61.0087 59.8849 71.3212 56 81.6015C54.8648 75.5065 53.7763 69.4049 52.7344 63.2968C53.4868 62.2213 54.0312 61.0468 54.3672 59.7734C54.5733 57.718 54.6879 55.6555 54.7109 53.5859C57.1677 52.5746 59.3734 51.1996 61.3281 49.4609Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.985,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1044 88.9999C23.7398 88.9999 15.3753 88.9999 7.01074 88.9999C6.98209 82.8695 7.01074 76.7392 7.09668 70.6093C7.81936 62.6462 11.6293 56.6878 18.5263 52.7344C23.0997 64.8032 27.6257 76.8919 32.1044 88.9999Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.986,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.6679 88.9999C75.3033 88.9999 66.9388 88.9999 58.5742 88.9999C63.0529 76.8919 67.5789 64.8032 72.1523 52.7344C79.0495 56.6878 82.8592 62.6462 83.582 70.6093C83.6679 76.7392 83.6966 82.8695 83.6679 88.9999Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.946,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0478 55.1484C42.4807 55.2423 43.9131 55.3567 45.3446 55.4922C46.7762 55.3567 48.2085 55.2423 49.6414 55.1484C49.67 56.2957 49.6414 57.4416 49.5555 58.5859C48.7811 61.1946 47.0336 62.3118 44.3134 61.9374C42.6045 61.4318 41.5447 60.3146 41.1337 58.5859C41.0478 57.4416 41.0193 56.2957 41.0478 55.1484Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0469 89C47.5781 89 43.1094 89 38.6406 89C39.856 81.4789 41.145 73.9737 42.5078 66.4844C44.3998 67.1717 46.2904 67.1717 48.1797 66.4844C49.5425 73.9737 50.8316 81.4789 52.0469 89Z",
    fill: "#02255B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6913 58.9574C75.4515 52.733 65.2117 52.733 58.9719 58.9574C52.732 65.1818 52.732 75.3963 58.9719 81.6207C65.2117 87.8452 75.2915 87.8452 81.5313 81.6207C87.7712 75.3963 87.9312 65.1818 81.6913 58.9574ZM74.8115 76.9923L70.3316 72.5235L65.8517 76.9923L63.6118 74.7579L68.0917 70.2891L63.6118 65.8202L65.8517 63.5858L70.3316 68.0546L74.8115 63.5858L77.0514 65.8202L72.5716 70.2891L77.0514 74.7579L74.8115 76.9923Z",
    fill: "#D81F1F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_18740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRemoveInspector);
export default __webpack_public_path__ + "static/media/logo-removeInspector.838274fe398f8d7a50a0f17d2d757152.svg";
export { ForwardRef as ReactComponent };